
import { useState } from "react";
import { cn } from "@/lib/utils";
import { useCamera } from "../hooks/useCamera";
import { useSelection } from "../hooks/useSelection";
import { SceneObjectList } from "./SceneObjectList";
import { ObjectInspector } from "./ObjectInspector";

// ─── ObjectsTab (Main Export) ───────────────────────────────

/**
 * Unified Objects tab with stacked layout:
 * - SceneObjectList (search + object list) always visible
 * - ObjectInspector shown below when an object is selected
 */
export function ObjectsTab() {
  const [searchQuery, setSearchQuery] = useState("");
  const { selectedObjectId, selectObject } = useSelection();
  const { centerOnObject } = useCamera();

  const handleSelect = (id: string) => {
    selectObject(id);
    centerOnObject(id);
  };

  return (
    <div className="flex flex-col h-full min-h-0 overflow-hidden">
      <div
        className={cn(
          "flex-1 min-h-0 overflow-hidden",
          selectedObjectId && "min-h-[8rem]",
        )}
      >
        <SceneObjectList
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          onSelect={handleSelect}
        />
      </div>

      {selectedObjectId && (
        <div className="flex-[1.4] min-h-0 border-t border-sands-200 overflow-y-auto">
          <ObjectInspector />
        </div>
      )}
    </div>
  );
}
